<template>
  <div class="questionnaire-root flex flex-col w-full min-h-0 overflow-hidden flex-1">
    <div class="questionnaire-page questionnaire-page-width box-border pt-0 my-0 mx-auto
          w-full flex-1 min-h-0
           overflow-hidden flex flex-col">
      <mission-complete-component v-if="getIsDone" />
      <assessment-expired-component v-if="getIsExpired" />
      <div v-if="!getIsDone && !getIsExpired" class="flex flex-wrap items-center justify-end gap-2 mb-2 shrink-0 w-full">
        <div class="top-actions-row">
          <Button
            type="button"
            unstyled
            class="btn-secondary"
            @click="summaryVisible = !summaryVisible"
          >
            <i class="pi pi-list" />
            <span class="action-label">{{ $t('QuestionnaireSidebar.summary', 'Summary') }}</span>
          </Button>
          <Button
            type="button"
            unstyled
            class="btn-secondary hotkeys-btn"
            @click="showHotkeysHint"
          >
            <i class="pi pi-keyboard" />
            <span class="action-label">{{ $t('QuestionnaireComponent.keyboardShortcuts') }}</span>
          </Button>
          <div class="lang-wrapper">
            <language-component v-if="true" />
          </div>
        </div>
      </div>
      <div v-if="!getIsDone && !getIsExpired"
       class="questionnaire-with-sidebar flex w-full flex-1 min-h-0 overflow-hidden" id="game">
        <div class="questionnaire-main-col flex flex-col items-stretch min-w-0 flex-1 min-h-0 overflow-hidden">
          <div class="question-container w-full flex-1 min-h-0 overflow-y-auto" id="tpl_questioncontainer">
            <div id="progress" class="progress-wrapper shrink-0">
              <div class="progress-bar" id="progressBar">
                <div class="progress-bar-fill"
                 id="progressBarFull" :style="getProgressStyle"></div>
              </div>
              <p id="progressText" class="progress-text">
                {{ getProgressText }}
              </p>
            </div>
            <div class="question-content flex-1 flex flex-col justify-center">
              <Transition name="question-fade" mode="out-in">
                <component :is="questionType" :key="getQuestionnaireIndex" />
              </Transition>
            </div>
          </div>
          <div class="nav-actions shrink-0">
            <Button
              type="button"
              unstyled
              id="btn_previous"
              class="btn-secondary nav-btn"
              @click.prevent="previousQuestion"
            >
              <i class="pi pi-arrow-left" aria-hidden="true"></i>
              <span>{{ $t('QuestionnaireComponent.previous') }}</span>
            </Button>
            <Button
              v-if="getShowNextButton"
              type="button"
              unstyled
              id="btn_next"
              data-testid="rg-btn-next"
              class="btn-primary-accent nav-btn"
              :disabled="submitDisabled"
              @click.prevent="nextQuestion"
            >
              <span>{{ $t('QuestionnaireComponent.next') }}</span>
              <i class="pi pi-arrow-right" aria-hidden="true"></i>
            </Button>
          </div>
        </div>
        <!-- Desktop: inline sidebar -->
        <aside
          v-show="summaryVisible"
          class="questionnaire-sidebar-col shrink-0 min-h-0 flex flex-col sidebar-desktop"
          aria-label="Summary"
        >
          <QuestionnaireSidebar />
        </aside>
      </div>
      <!-- Mobile: overlay sidebar -->
      <Transition name="sidebar-slide">
        <div
          v-if="summaryVisible"
          class="sidebar-overlay"
          @click.self="summaryVisible = false"
        >
          <div class="sidebar-overlay-panel">
            <div class="sidebar-overlay-header">
              <span class="sidebar-overlay-title">{{ $t('QuestionnaireSidebar.summary', 'Summary') }}</span>
              <button type="button" class="sidebar-overlay-close" @click="summaryVisible = false">
                <i class="pi pi-times" />
              </button>
            </div>
            <QuestionnaireSidebar />
          </div>
        </div>
      </Transition>
    </div>
  </div>
  <provide-feedback-component></provide-feedback-component>
</template>

<script>
import SliderQuestion from '@/components/Home/QuestionnaireComponent/SliderQuestion.vue';
import TextQuestion from '@/components/Home/QuestionnaireComponent/TextQuestion.vue';
import KssChampionQuestion from '@/components/Home/QuestionnaireComponent/KssChampionQuestion.vue';
import KssChampionUserListQuestion
  from '@/components/Home/QuestionnaireComponent/KssChampionUserListQuestion.vue';
import IntegrativeComplexityQuestion
  from '@/components/Home/QuestionnaireComponent/IntegrativeComplexityQuestion.vue';
import MissionCompleteComponent
  from '@/components/Home/QuestionnaireComponent/MissionCompleteComponent.vue';
import AssessmentExpiredComponent
  from '@/components/Home/QuestionnaireComponent/AssessmentExpiredComponent.vue';
import ProvideFeedbackComponent from '@/components/global/ProvideFeedbackComponent.vue';
import { Button } from 'primevue';
import LanguageComponent from '@/components/global/LanguageComponent.vue';
import NetworkAssessment from '@/helpers/networking/NetworkAssessment';
import { isAnswerMissingForQuestionnaire } from '@/helpers/questionnaireValidation';
import QuestionnaireSidebar from '@/components/Home/QuestionnaireComponent/QuestionnaireSidebar.vue';
import useQuestionnaireHotkeys from '@/composables/useQuestionnaireHotkeys';
// eslint-disable-next-line import/no-cycle
import NetworkAuth from '@/helpers/networking/NetworkAuth';
import AssessmentHelper from '@/helpers/AssessmentHelper';

export default {
  props: ['id'],
  name: 'QuestionnaireComponent',
  components: {
    AssessmentExpiredComponent,
    MissionCompleteComponent,
    IntegrativeComplexityQuestion,
    KssChampionQuestion,
    KssChampionUserListQuestion,
    SliderQuestion,
    TextQuestion,
    ProvideFeedbackComponent,
    Button,
    LanguageComponent,
    QuestionnaireSidebar,
  },
  data() {
    return {
      submitDisabled: false,
      summaryVisible: typeof window !== 'undefined' && window.innerWidth >= 1024,
    };
  },
  computed: {
    questionType() {
      return this.$store.getters.getSelectedQuestionType;
    },
    getProgressText() {
      return this.$store.getters.getSelectedQuestionProgressText;
    },
    getChapterText() {
      return this.$store.getters.getSelectedQuestionChapterText;
    },
    getQuestionnaireIndex() {
      return this.$store.getters.getQuestionnaireIndex;
    },
    getProgressStyle() {
      return `width: ${this.$store.getters.getProgress}%;`;
    },
    getIsDone() {
      return this.$store.state.questionnaireManagement.isDone;
    },
    getIsExpired() {
      return this.$store.state.questionnaireManagement.isExpired;
    },
    getForceInput() {
      return this.$store.state.questionnaireManagement.forceInput;
    },
    getAnswer() {
      return this.$store.state.questionnaireManagement.answer;
    },
    getShowNextButton() {
      return this.$store.getters.getShowNextButton;
    },
  },
  methods: {
    async nextQuestion() {
      try {
        this.submitDisabled = true;
        if (this.questionType !== 'IntegrativeComplexityQuestion') {
          // forceInput = CMS "Require user input"; sticky alone does not block Next
          if (this.getForceInput) {
            if (isAnswerMissingForQuestionnaire(this.getAnswer)) {
              this.$toast.add({
                severity: 'error',
                summary: this.$t('ToastComponent.questionnaire.noInputErr'),
                detail: '',
                life: 3000,
              });
              this.submitDisabled = false;
              return;
            }
          }
        }
        await this.$store.dispatch('setNextQuestion');
        this.submitDisabled = false;
      } catch (error) {
        this.submitDisabled = false;
        this.$toast.add({
          severity: 'error',
          summary: error.response?.data?.message || 'An error occurred',
          detail: '',
          life: 3000,
        });
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    previousQuestion() {
      this.$store.dispatch('setPreviousQuestion');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    showHotkeysHint() {
      this.$toast.add({
        severity: 'info',
        summary: this.$t('QuestionnaireComponent.keyboardShortcuts'),
        detail: this.$t('QuestionnaireComponent.hotkeysHint'),
        life: 8000,
      });
    },
  },
  beforeUnmount() {
    if (this._hotkeyCleanup) this._hotkeyCleanup();
  },
  async mounted() {
    try {
      // Check for external access token in URL (for non-platform users)
      const { externalToken } = this.$route.query;
      const existingJwt = localStorage.getItem('jwt') || localStorage.getItem('token');

      if (externalToken && this.id) {
        // Always exchange for a fresh JWT when externalToken is in the URL.
        // A stale/expired JWT from a previous visit (e.g. user closed the tab
        // without Vue Router navigation) would skip auth and cause 401 errors
        // on answer updates while the assessment itself still loads.
        localStorage.removeItem('jwt');
        try {
          const { data } = await NetworkAssessment.authenticateExternal(this.id, externalToken);
          if (data.token) {
            localStorage.setItem('jwt', data.token);
            console.log('External user authenticated successfully');
          }
        } catch (authError) {
          console.error('External authentication failed:', authError);
          this.$toast.add({
            severity: 'error',
            summary: 'Authentication failed. The link may be invalid or expired.',
            detail: '',
            life: 5000,
          });
          return;
        }
      } else if (!existingJwt) {
        // Internal user with no session: redirect to login, then come back
        this.$router.push({ path: '/auth', query: { redirect: this.$route.fullPath } });
        return;
      }

      if (existingJwt && !externalToken && NetworkAuth.isTokenExpired(existingJwt)) {
        try {
          await this.$store.dispatch('refreshToken');
        } catch {
          this.$router.push({ path: '/auth', query: { redirect: this.$route.fullPath } });
          return;
        }
      }

      await this.$store.dispatch('getAssessment', {
        id: this.id,
        locale: this.$i18n.locale,
      });

      const assessment = this.$store.state.questionnaireManagement.assessment;
      const terminalStatuses = ['submitted', 'expired', 'canceled', 'scheduled'];
      if (!this.$route.query.fromIntro
        && !terminalStatuses.includes(assessment.status)
        && this.$store.getters.getQuestionnaireIndex === 0
        && AssessmentHelper.hasRenderableIntro(assessment, this.$i18n.locale)) {
        if (this.$route.query.externalToken) {
          this.$router.replace({
            path: '/evaluation/assessment-intro',
            query: { id: this.id, externalToken: this.$route.query.externalToken },
          });
        } else {
          this.$router.replace({ path: '/assessment-intro', query: { id: this.id } });
        }
        return;
      }

      if (this.$store.state.questionnaireManagement.assessment.type === 'kss'
        && !['expired', 'canceled', 'scheduled'].includes(this.$store.state.questionnaireManagement.assessment.status)) {
        this.$store.commit('addFrontendOverlay', {
          id: Math.random(),
          type: 'introKssTracker',
          assessment: this.$store.state.questionnaireManagement.assessment,
        });
      }
      if (this.$store.state.questionnaireManagement.assessment.status === 'submitted') {
        this.$store.commit('setIsDone', true);
      }

      if (['expired', 'canceled', 'scheduled'].includes(this.$store.state.questionnaireManagement.assessment.status)) {
        this.$store.commit('setIsExpired', true);
      }

      this._hotkeyCleanup = useQuestionnaireHotkeys({
        store: this.$store,
        onNext: () => this.nextQuestion(),
        onPrevious: () => this.previousQuestion(),
        onToggleSummary: () => { this.summaryVisible = !this.summaryVisible; },
        getIsActive: () => !this.getIsDone && !this.getIsExpired,
        getCanGoNext: () => this.getShowNextButton && !this.submitDisabled,
        getCanGoPrevious: () => this.getQuestionnaireIndex > 0,
        getQuestionType: () => this.questionType,
      });
      this.tokenRefresher = setInterval(async () => {
        const { token } = this.$store.state.auth;
        if (token && NetworkAuth.isTokenExpired(token, 600000)) {
          try {
            await this.$store.dispatch('refreshToken');
          } catch {
            clearInterval(this.tokenRefresher);
            this.$router.push({ path: '/auth', query: { redirect: this.$route.fullPath } });
          }
        }
      }, 300000);
    } catch (error) {
      console.error('QuestionnaireComponent mounted error:', error);

      // Handle different error types
      if (error.response && error.response.data) {
        if (error.response.data.status === 418) {
          this.$router.push('/not-found');
          return;
        }

        this.$toast.add({
          severity: 'error',
          summary: error.response.data.message || 'An error occurred',
          detail: '',
          life: 3000,
        });
      } else {
        // Handle network errors or other types of errors
        this.$toast.add({
          severity: 'error',
          summary: 'Network error or assessment not found',
          detail: '',
          life: 3000,
        });
      }
    }
  },
  // Clean up temporary JWT for external users BEFORE navigation happens.
  // This runs before the target route loads, so the JWT is gone before
  // any other page can use it to access platform data.
  beforeRouteLeave(to, from, next) {
    if (from.query.externalToken) {
      localStorage.removeItem('jwt');
    }
    next();
  },
  unmounted() {
    clearInterval(this.tokenRefresher);
    this.$store.commit('removeInvolvedUsers');
    this.$store.commit('setIsDone', false);
    this.$store.commit('setIsExpired', false);
  },
};
</script>

<style scoped>
/* Responsive typography: font sizes scale with viewport (relative to display size) */
.questionnaire-page {
  font-family: AsenPro, sans-serif;
  font-size: clamp(1.125rem, 2.5vw + 0.5rem, 1.5rem);
}

.questionnaire-page-width {
  max-width: 100%;
}

.questionnaire-with-sidebar {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 1.25rem;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  min-height: 0;
}

.questionnaire-main-col {
  flex: 1;
  min-width: 0;
  min-height: 0;
}

.questionnaire-sidebar-col {
  flex-shrink: 0;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.top-actions-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  height: 2.75rem;
  min-height: 2.75rem;
}

.lang-wrapper {
  height: 2.75rem;
  min-width: 2.75rem;
  padding: 0 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.question-container {
  background: var(--color-milk);
  border-radius: 0.75rem;
  box-sizing: border-box;
  padding: clamp(0.375rem, 1vw, 0.625rem) clamp(0.75rem, 2vw, 1.25rem);
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.progress-wrapper {
  margin-bottom: clamp(0.25rem, 0.8vw, 0.5rem);
}

.question-content {
  min-height: min-content;
}

.progress-bar {
  width: 100%;
  height: clamp(0.3rem, 0.8vw, 0.4rem);
  border-radius: 9999px;
  overflow: hidden;
  background: var(--color-grey);
  margin-bottom: 0.125rem;
}

.progress-bar-fill {
  height: 100%;
  min-width: 0;
  border-radius: 9999px;
  background: var(--accent-gradient-horizontal);
  transition: width 0.3s ease;
}

.progress-text {
  color: rgba(30, 32, 25, 0.75);
  font-size: clamp(0.75rem, 1vw + 0.2rem, 0.875rem);
  font-weight: 400;
  margin: 0;
  line-height: 1.3;
}

.nav-actions {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: clamp(0.5rem, 1.5vw, 1rem);
  margin-bottom: clamp(0.5rem, 1vw, 0.75rem);
  width: 100%;
  gap: 1rem;
  min-height: 2.75rem;
  flex-shrink: 0;
}

.nav-btn {
  gap: 0.5rem;
  padding: 0.625rem 1.5rem;
  min-height: 2.75rem;
  font-size: 1rem;
}

/* Question transition */
.question-fade-enter-active,
.question-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.question-fade-enter-from {
  opacity: 0;
  transform: translateY(8px);
}

.question-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* ---- Mobile overlay sidebar (hidden on desktop) ---- */
.sidebar-overlay {
  display: none;
}

/* ---- Mobile responsive (<1024px) ---- */
@media (max-width: 1023px) {
  .questionnaire-page {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 0.5rem;
  }

  .questionnaire-page-width {
    max-width: 100%;
  }

  .sidebar-desktop {
    display: none !important;
  }

  .sidebar-overlay {
    display: flex;
    position: fixed;
    inset: 0;
    z-index: 200;
    background: rgba(0, 0, 0, 0.4);
    align-items: flex-end;
    justify-content: center;
  }

  .sidebar-overlay-panel {
    background: #fff;
    border-radius: 1rem 1rem 0 0;
    width: 100%;
    max-height: 75vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.15);
  }

  .sidebar-overlay-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid var(--color-light-grey, #e7e7e7);
    flex-shrink: 0;
  }

  .sidebar-overlay-title {
    font-weight: 600;
    font-size: 1.125rem;
    color: var(--color-dark, #1E2019);
  }

  .sidebar-overlay-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: none;
    background: var(--color-light-grey, #e7e7e7);
    border-radius: 50%;
    cursor: pointer;
    font-size: 1rem;
    color: var(--color-dark, #1E2019);
  }

  .sidebar-overlay-panel :deep(.questionnaire-sidebar) {
    border: none;
    border-radius: 0;
    width: 100%;
    max-width: 100%;
    overflow-y: auto;
  }

  .sidebar-slide-enter-active,
  .sidebar-slide-leave-active {
    transition: opacity 0.25s ease;
  }

  .sidebar-slide-enter-active .sidebar-overlay-panel,
  .sidebar-slide-leave-active .sidebar-overlay-panel {
    transition: transform 0.3s ease;
  }

  .sidebar-slide-enter-from,
  .sidebar-slide-leave-to {
    opacity: 0;
  }

  .sidebar-slide-enter-from .sidebar-overlay-panel {
    transform: translateY(100%);
  }

  .sidebar-slide-leave-to .sidebar-overlay-panel {
    transform: translateY(100%);
  }

  .hotkeys-btn {
    display: none !important;
  }

  .action-label {
    display: none;
  }

  .top-actions-row {
    gap: 0.25rem;
  }

  .question-container {
    padding: 0.375rem 0.5rem;
    border-radius: 0.5rem;
  }

  .nav-actions {
    margin-top: 0.5rem;
    margin-bottom: 0.375rem;
    gap: 0.5rem;
  }

  .nav-btn {
    flex: 1;
    justify-content: center;
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
  }
}

/* Small phones */
@media (max-width: 480px) {
  .questionnaire-page {
    padding: 0 0.25rem;
  }

  .question-container {
    padding: 0.375rem 0.5rem;
  }
}
</style>
